import { ApiProperty } from '@nestjs/swagger';
import { IsNotEmpty, IsOptional, IsUUID } from 'class-validator';

export class CreateAsignacionDto {
  @ApiProperty({ description: 'ID de la sucursal', example: 'uuid' })
  @IsNotEmpty()
  @IsUUID()
  sucursal_id: string;

  @ApiProperty({ description: 'ID del usuario', example: 'uuid', required: false })
  @IsOptional()
  @IsUUID()
  usuario_id?: string;

  @ApiProperty({ description: 'ID de la caja', example: 'uuid', required: false })
  @IsOptional()
  @IsUUID()
  caja_id?: string;
}
